import { createFileRoute } from "@tanstack/react-router";
import Rewards from "@/pages/Rewards";
import { MainLayout } from "@/components/layout/MainLayout";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

export const Route = createFileRoute("/rewards")({
  head: () => ({
    meta: [
      { title: "Your Rewards — Referrals & Profile Credits | Statlign" },
      { name: "description", content: "Track your Statlign referral and profile rewards, pending credits and unlock dates." },
      { property: "og:title", content: "Your Rewards — Referrals & Profile Credits | Statlign" },
      { property: "og:description", content: "Track your Statlign referral and profile rewards, pending credits and unlock dates." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <ProtectedRoute>
        <Rewards />
      </ProtectedRoute>
    </MainLayout>
  ),
});
